import React, { useRef, useState } from "react";
import { kFormatter, percentageFormatter } from "../utils";
import moment from "moment";
import DimmerComponent from "../../DimmerComponent";
import NoData from "../NoData/NoData";
import { Icon } from "semantic-ui-react";
import { Dropdown } from "semantic-ui-react";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { ReactComponent as DownloadIcon } from "../../../../../assets/svg/downloads.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import html2canvas from "html2canvas";
import { downloadCSVData, downloadCanvasWithTitle } from "../utils";
import "./TotalValueCharts.scss";
import DownloadChart from "../DownloadChart";

function TotalUniqueUsers(props) {
    const chartEl = useRef();
    let nodata = !props.data || props.noTopicsSelected;

    let current = props.data?.current;
    let previous = props.data?.previous;

    const renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    };

    const downloadPNG = (cb, options) => {
        if (props.isFreeTierPackage) {
            props.packageUpgradePopup();
            return;
        }

        return html2canvas(chartEl.current, { backgroundColor: options.background ? "#fff" : null }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, props.widget.name);
        });
    };

    const downloadCSV = () => {
        if (props.isFreeTierPackage) {
            props.packageUpgradePopup();
            return;
        }
        const columns = [["Duration"], ["Current Total"], ["Previous Total"], ["Percentage Change"]];

        const formatString = "YYYY-MM-DD HH:mm";
        let tz = JSON.parse(localStorage.company).user_timezone_name;

        if (!["custom", "24HRS", "1", "lastmonth", "lastquarter", "last2quarter"].includes(props.appliedFilter.duration))
            columns[0].push(props.appliedFilter.duration + " days");
        else {
            const startDate = moment(props.appliedFilter.start_date);
            const endDate = moment(props.appliedFilter.end_date);
            const now = moment(new Date());
            const duration = moment.duration(endDate.diff(startDate, "days")) + 1;

            if (props.appliedFilter.duration === "24HRS") {
                const startDate = moment(new Date())
                    .tz(tz)
                    .subtract(1440 - 1, "minutes")
                    .format("YYYY-MM-DDTHH:mm:ss");
                const endDate = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");

                columns[0].push(`${moment(startDate).format(formatString)} - ${moment(endDate).format(formatString)}`);
            } else if (props.appliedFilter.duration === "1") {
                columns[0].push("Today");
            } else if (props.appliedFilter.duration === "custom") {
                if (props.appliedFilter.rollingDate) {
                    columns[0].push(`${startDate.format(formatString)} - ${now.format(formatString)}`);
                } else columns[0].push(`${startDate.format(formatString)} - ${endDate.format(formatString)}`);
            } else if (props.appliedFilter.duration === "lastmonth") {
                columns[0].push("Last Month");
            } else if (props.appliedFilter.duration === "lastquarter") {
                columns[0].push("Last Quarter");
            } else if (props.appliedFilter.duration === "last2quarter") {
                columns[0].push("Last 2 Quarters");
            } else {
                if (duration > 1) columns[0].push(duration + " days");
                else columns[0].push(duration + " day");
            }
        }
        columns[1].push(current);
        columns[2].push(previous);

        let percentageChange =
            previous === 0
                ? "N/A"
                : current > previous
                ? `+ve ${!isFinite((((current - previous) / previous) * 100).toFixed(2)) ? 0 : (((current - previous) / previous) * 100).toFixed(2)}%`
                : current === previous
                ? "0 %"
                : `-ve ${!isFinite((((previous - current) / previous) * 100).toFixed(2)) ? 0 : (((previous - current) / previous) * 100).toFixed(2)}%`;

        columns[3].push(percentageChange);

        let csvFmt = columns[0].map((col, i) => columns.map((row) => row[i]));

        downloadCSVData(csvFmt, props.widget.name);
    };

    return (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName name={props.widget.name} info="This chart shows total unique users for the selected filters." />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )}
                    {!props.isPublic && !props.isResearchDashboard && <>{renderDownloadButton(nodata)}</>}
                    {!props.isPublic && <MoreOptions className="more-options" onClick={(e) => props.changeShowMoreOptions(e)} />}
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {!props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <>
                                <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings />
                                </div>
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                            </>
                        )}
                    {!props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && <DeleteWidget onClick={props.deleteWidget} />}
                </ChartOptionsSidebar>
            )}
            {!nodata ? (
                <div className="dashboard-chart" ref={chartEl}>
                    <div className="dashboardTotalValueCharts">
                        <div className="header">
                            <p className="row-2">Unique users</p>
                        </div>
                        <div className="currentPeriod">
                            <p className="row-1">{kFormatter(current)}</p>
                            {previous === 0 ? (
                                <div className="percentageChange">
                                    <p style={{ marginLeft: "10px" }}>N/A</p>
                                </div>
                            ) : current === previous ? (
                                <div className="percentageChange">
                                    <p>0%</p>
                                </div>
                            ) : current > previous ? (
                                <div className="percentageChange">
                                    <p>
                                        <Icon name="long arrow alternate up" color="green" size="large" />
                                    </p>
                                    <p>{percentageFormatter((((current - previous) / previous) * 100).toFixed(1))}%</p>
                                </div>
                            ) : previous > current ? (
                                <div className="percentageChange">
                                    <p>
                                        <Icon name="long arrow alternate down" color="red" size="large" />
                                    </p>
                                    <p>{percentageFormatter((((previous - current) / previous) * 100).toFixed(1))}%</p>
                                </div>
                            ) : null}
                        </div>
                        <div className="previousPeriod">
                            <p className="row-2">Previous Period</p>
                            <p className="row-1">{kFormatter(previous)}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <NoData
                    message={
                        !props.isPublic && props.noTopicsSelected
                            ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                            : null
                    }
                />
            )}
        </>
    );
}

export default TotalUniqueUsers;
